import { render, staticRenderFns } from "./ViewMore.vue?vue&type=template&id=f33e0080&"
import script from "./ViewMore.vue?vue&type=script&lang=js&"
export * from "./ViewMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports